import {
  EntitlementsProject,
  PROJECT_CLASSIFICATION_TYPES,
  ENTITLEMENTS_PLATFORM_TYPES,
} from '@adsk/alloy-provider';
import { DefaultPaginatedResponse } from '../clients/admin';
import { ProjectsObject } from '../models';
import { isComponentLibraryProject } from './isComponentLibraryProject';
import { mergeResponsesData } from './responseHelpers';

export const isProjectTemplate = (project: EntitlementsProject) =>
  project.classification === PROJECT_CLASSIFICATION_TYPES.TEMPLATE;

export const isAcsUnified = (project: EntitlementsProject) =>
  project.platform === ENTITLEMENTS_PLATFORM_TYPES.ACC;

export const getProjectsAsList = (
  projectsObj: ProjectsObject
): EntitlementsProject[] => {
  if (!projectsObj) return [];
  return Object.keys(projectsObj).map(
    (id): EntitlementsProject => projectsObj[id]
  );
};

export const parseProjectEntitlementsResponse = (
  projectsResponses: DefaultPaginatedResponse<EntitlementsProject>[]
) => {
  const templates: ProjectsObject = {},
    projects: ProjectsObject = {};
  mergeResponsesData(projectsResponses).forEach((project) => {
    if (isProjectTemplate(project)) {
      // removing component project library (another product that we should filter currently returned as a template from admin)
      if (project.name && !isComponentLibraryProject(project.name))
        templates[project.id] = project;
    } else projects[project.id] = project;
  });
  return {
    projects,
    templates,
  };
};
